import React, { useEffect, useMemo, useRef, useState } from 'react'
import ApproachesMobile from '../../Approaches/ApproachesMobile'
import styles from "./Service.module.css"
import Circle from "../../CenterCircle/Circle"
import CircleMObile from "../../CenterCircle/CircleMobile"
export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])
    // //console.log(isInters ecting);
    return isIntersecting
}
function Service() {
    const [showClass, setShowClass] = useState('')
    const ref = useRef()
    const isVisible = useOnScreen(ref)
    useEffect(() => {
       
            setShowClass('showservice')
        
    }, [])
    return (
        <div className={`${styles.Service}`} >

            <div data-aos = 'slide-right' className={styles.Servicemain}>
                <div className={styles.ServiceLeft}>
                    <h4>私たちが提供するもの</h4>
                    <div className={styles.puffincenter}>
                        <p>株式会社SHARVIL が提供することができるものは多岐にわたります。</p>
                            <br />
                        <p>ITのリソースが豊富なインドを拠点として、10年以上のIT業界における経験を活用したソリューションを提供できます。また、ITのソリューションの活用方法を熟知した経験豊富なコンサルタントがそれらのソリューションと合わさり、顧客の抱える課題をシンプルかつ効率的に解決します。</p>
                    <br />
                        <p>株式会社SHARVIL のもつ世界中のネットワークは顧客の新たな事業領域の開発、世界市場への進出をサポートできます。
                        </p>
                    </div>
                </div>
                
                <div ref={ref} className={`${styles.ServiceRight}   `} >
                    <Circle/>
                    <CircleMObile/>
                </div>
            </div>
            
        </div>
    )
}

export default Service